import React, { useEffect, useState, useCallback } from 'react';
import {
  Tag,
  Button,
  Card,
  Checkbox,
  Col,
  Modal,
  DatePicker,
  Form,
  Input,
  Pagination,
  message,
  Row,
  Select,
  Space,
  Switch,
  Tooltip,
  Table
} from 'antd';
import { useFetchPageData, usePageData } from '../../../hooks/usePage';
import { IAppointment } from '../../../interfaces/patient';
import { IPageData } from '../../../interfaces/page';
import { Divider } from 'antd';
// import jwt_decode from 'jwt-decode';
// import { QuestionCircleOutlined } from '@ant-design/icons';
import generalesProvider from '../../../services/generalesProvider';
// import administracionProvider from '../../../services/administracionProvider';
// import seguridadProvider from '../../../services/seguridadProvider';
// import locale from 'antd/es/date-picker/locale/es_ES';

const moment = require('moment');
const { Option } = Select;
const pageData: IPageData = {
  fulFilled: true,
  breadcrumbs: [
    {
      title: 'Administración de Categoria',
      route: 'administracion-categoria'
    },
    {
      title: 'Categoria'
    }
  ]
};

const key = 'regitrando';
const pageSize = 5;
const PaginacionPersonalizada = ({ total, onChange, current }) => {
  return (
    <Pagination onChange={onChange} simple={true} total={total} current={current} pageSize={pageSize} />
  );
};
const AdministracionCategoria = () => {
  usePageData(pageData);
  const [data, setData] = useState({ data: [], totalRecords: 0 });
  const [current, setCurrent] = useState(1);
  const [formFile] = Form.useForm();
  const columns = [
    {
      title: 'Nombre Categoria',
      dataIndex: 'descripcionvalor',
      key: 'descripcionvalor',
      render: text => <a>{text}</a>,
      width: '85%'
    },
    {
      title: 'Action',
      key: 'action',
      render: (text, record) => {

        return (
          <Space size='middle'>
            <Button size='small' type='primary' onClick={(e) => btnEditarCategoria(text)}>Editar</Button>
            <Button size='small' type='primary' onClick={(e) => btnEliminarCategoria(text)} danger>Eliminar</Button>
          </Space>
        );
      },
      align: 'center' as 'center'
    }
  ];
  const onSubmitCrearFileOk = useCallback(async (values) => {
    console.log('se crea archivo');
    var request = {
      id: values.getFieldValue('id') === undefined ? 0 : parseInt(values.getFieldValue('id')),
      descripcionvalor: values.getFieldValue('descripcionvalor'),
      skeycab: 'SKEYCATEGORIAGESTIONDOCUMENTO'
    };
    const res: any = await generalesProvider.Registrar_Actualizar_Categoria(request);
    if (res.succeeded) {
      message.success(res.message);
      listarCategoria();
      /*Reseteamos el formulario  */
      formFile.resetFields();
    } else {
      message.error('Ocurreo un error al intentar crear el archivo');
    }
  }, []);
  const listarCategoria = async () => {
    const paginacion = {
      pagenum: current,
      pagesize: pageSize,
      skeycab: 'SKEYCATEGORIAGESTIONDOCUMENTO'
    };
    const res: any = await generalesProvider.ListarCategoriaPaginado(paginacion);
    if (res.data) setData(res);
  };
  useEffect(() => {
    listarCategoria();
  }, [current]);

  const btnEditarCategoria = (data) => {

    formFile.setFieldsValue({
      id: data.id,
      descripcionvalor: data.descripcionvalor
    }); //seteamos el
  };
  const btnEliminarCategoria = (data) => {

    Modal.confirm({
      title: 'GESSOMA',
      content: 'Esta seguro que desea eliminar categoria',
      okText: 'Ok',
      cancelText: 'Cancelar',
      onCancel: () => {
      },
      onOk: async () => {

        const res : any = await generalesProvider.Eliminar_Categoria({ id: data.id });
        if (res.succeeded) {
          message.success(res.message);
          listarCategoria();
        } else {
          message.error('Ocurreo un error al intentar crear el archivo');
        }
      }
    });
  };
  const formItemLayout = {
    labelCol: {
      xs: {
        span: 24
      },
      sm: {
        span: 8
      }
    },
    wrapperCol: {
      xs: {
        span: 24
      },
      sm: {
        span: 16
      }
    }
  };

  return (
    <>
      <Card title={'Administración de Categoria'}>
        <div className='row'>
          <div className='col-md-4'>
            <div className='row'>
              <div className='col-md-12'>
                <Form {...formItemLayout}
                      form={formFile}
                      onFinish={() => onSubmitCrearFileOk(formFile)} name='register'
                  // onFinish={onFinish} initialValues={usuario}
                      scrollToFirstError>
                  <Form.Item name='descripcionvalor' label='Nombre Categoria.'
                             rules={[{ required: true, message: 'Nombre categoria es requerido!' }]}
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item label='id' name='id' noStyle>
                    <Input type='hidden' />
                  </Form.Item>
                </Form>
              </div>
            </div>
            <div className='row'>
              <div className='col-md-12'>
                <Row justify={'center'}>
                  <Col>
                    <Form.Item>
                      <Space size={'middle'}>
                        <Button type='primary' block onClick={formFile.submit}>
                          Guardar
                        </Button>
                      </Space>
                    </Form.Item>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
          <Divider type='vertical' style={{ height: 'auto' }} />
          <div className='col-md-7'>
            <div className='row'>
              <div className='col-md-12'>
                <Table locale={{ emptyText: 'No existen registros' }} pagination={false} columns={columns}
                       dataSource={data.data}
                       bordered />
                <Row justify={'center'}>
                  <Col>
                    <PaginacionPersonalizada total={data.totalRecords} current={current} onChange={setCurrent} />
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
      </Card>
    </>
  );
};
export default AdministracionCategoria;